var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',[_c('v-data-table',{attrs:{"dense":"","headers":_vm.statusHeaders,"items":_vm.history,"hide-default-footer":"","items-per-page":-1},scopedSlots:_vm._u([{key:"item.StartDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.displayDate(new Date(item.StartDate))))])]}},{key:"item.EndDate",fn:function(ref){
var item = ref.item;
return [_c('span',[_vm._v(_vm._s(_vm.displayDate(new Date(item.EndDate))))])]}}],null,true)})],1)}
var staticRenderFns = []

export { render, staticRenderFns }